
import { defineComponent, PropType } from "vue";

import Player from "@/models/Player";

export default defineComponent({
  inject: ["game"],
  props: {
    playerId: { type: Number },
    player: { type: Object as PropType<Player> },
  },
  computed: {
    actualPlayer(): { id: number; name: string } | undefined {
      return this.player ?? this.game.getPlayer(this.playerId!);
    },
  },
});
